module.exports = __webpack_public_path__ + "static/media/4.10_preview.dd06df37.png";